
export const rateOptions = [
  { value: null, text: 'Choose rating' },
  { value: 1, text: '1 (lowest)' },
  { value: 2, text: '2' },
  { value: 3, text: '3' },
  { value: 4, text: '4' },
  { value: 5, text: '5 (best)' },
]

export const dayOffReasons = [
  { value: null, text: 'Choose a reason' },
  { value: 'Annual leave', text: 'Annual leave' },
  { value: 'Sick', text: 'Sick' },
  { value: 'Training', text: 'Training' },
  { value: 'Public holiday', text: 'Public holiday' },
  { value: 'Personal', text: 'Personal' },
  { value: 'Other', text: 'Other' },
]

export const timeOptions = [
  '00:00',
  '01:00',
  '02:00',
  '03:00',
  '04:00',
  '05:00',
  '06:00',
  '07:00',
  '08:00',
  '09:00',
  '10:00',
  '11:00',
  '12:00',
  '13:00',
  '14:00',
  '15:00',
  '16:00',
  '17:00',
  '18:00',
  '19:00',
  '20:00',
  '21:00',
  '22:00',
  '23:00',
]
